import { render } from "./Caigou.vue?vue&type=template&id=09ee3f73"
import script from "./Caigou.vue?vue&type=script&lang=js"
export * from "./Caigou.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__